import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*eslint max-lines: off */
import { useCallback, useRef, } from 'react';
import clsx from 'clsx';
import { Box, IconButton, InputAdornment, InputLabel, TextField, Typography, } from '@mui/material';
import { DateRange as DateRangeIcon } from '@mui/icons-material';
import { Translation } from '../Translation';
import { InputTypes } from '../../enums/InputTypes';
import useInputLabelDisplay from '../../hooks/useInputLabelDisplay';
export const GenericInput = ({ label, required, id, onChange, onFocus, onKeyDown, value, disabled, currentError, type, inputLabel, inputMode, datePicker, toggleDatePicker, startAdornment, endAdornment, params, placeholder, classes, readOnly, onBlur, inputLabelTooltip, fullWidth, }) => {
    const inputRef = useRef(null);
    const { getLabel } = useInputLabelDisplay();
    const displayedLabel = getLabel(label);
    const handleFocus = useCallback(() => onFocus && onFocus(id, value), [onFocus, id, value]);
    return (_jsxs(Box, { className: classes?.fieldWrapper, children: [inputLabel !== false && (_jsxs(Box, { className: classes?.labelContainer, children: [_jsx(InputLabel, { htmlFor: id, required: required, className: classes?.label, classes: {
                            asterisk: classes?.labelAsterisk,
                        }, "data-test": `text_input:label:${id}`, children: _jsx(Typography, { component: "span", variant: "subtitle1", children: displayedLabel }, void 0) }, void 0), inputLabelTooltip] }, void 0)), _jsx(TextField, { "data-test": `text_input:${id}`, id: id, ...(type !== InputTypes.EMAIL && {
                    type,
                }), fullWidth: fullWidth, inputMode: inputMode, variant: "outlined", className: clsx([
                    classes?.input,
                    {
                        ...(classes?.inputNoLabel && {
                            [classes.inputNoLabel]: inputLabel === false,
                        }),
                    },
                ]), placeholder: placeholder || label, value: value, disabled: disabled, error: !!currentError, onChange: onChange, onFocus: handleFocus, onKeyDown: onKeyDown, onBlur: onBlur, helperText: currentError && (_jsx(Translation, { ...currentError.props, component: "Typography", componentProps: { component: 'span', variant: 'caption' }, className: classes?.errorText, "data-test": `text_input:error:${id}` }, void 0)), InputProps: {
                    ...params?.InputProps,
                    readOnly: !!readOnly,
                    classes: {
                        root: classes?.root,
                        focused: classes?.focused,
                        error: classes?.inputError,
                        notchedOutline: classes?.notchedOutline,
                        disabled: classes?.disabled,
                    },
                    onBlur,
                    endAdornment: endAdornment ? (endAdornment) : (_jsx(InputAdornment, { position: "end", children: datePicker && (_jsx(IconButton, { onClick: () => {
                                if (toggleDatePicker) {
                                    toggleDatePicker(true, inputRef?.current);
                                }
                            }, component: "span", className: classes?.dateCalendar, children: _jsx(DateRangeIcon, { fontSize: "small" }, void 0) }, void 0)) }, void 0)),
                    startAdornment: startAdornment,
                }, FormHelperTextProps: {
                    classes: {
                        root: classes?.helperTextError,
                    },
                }, inputProps: { ...params?.inputProps }, ref: inputRef }, void 0)] }, void 0));
};
export default GenericInput;
//# sourceMappingURL=GenericInput.js.map